import { useEffect, useState } from 'react';
import { useDebouncedCallback } from '@mantine/hooks';

import { IconType } from '../Icons/HudIcons';
import { Icon, InputElement, InputVariants } from './Input.styles';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  icon?: IconType;
  variant?: keyof typeof InputVariants;
  debounced?: number;
}

export function Input({
  value,
  onChange,
  icon,
  variant = 'default',
  className,
  debounced,
  ...rest
}: InputProps) {
  const [internalValue, setInternalValue] = useState(value || '');

  const debounceOnChangeEvent: (e: React.ChangeEvent<HTMLInputElement>) => void =
    useDebouncedCallback((e) => {
      if (onChange) {
        onChange(e);
      }
    }, debounced || 0);

  useEffect(() => {
    if (value !== undefined && value !== internalValue) {
      setInternalValue(value);
    }
  }, [value]);

  const VariantContainer = InputVariants[variant] || InputVariants.default;
  return (
    <VariantContainer className={className}>
      {icon && <Icon icon={icon} size={'20px'} aria-hidden="true" />}
      <InputElement
        type="text"
        {...rest}
        value={internalValue}
        onChange={(e) => {
          setInternalValue(e.target.value);
          if (debounced) {
            debounceOnChangeEvent(e);
          } else {
            if (onChange) {
              onChange(e);
            }
          }
        }}
      />
    </VariantContainer>
  );
}
